var min = {
  sm: '@media (min-width: 35.5em)',
  md: '@media (min-width: 48em)',
  lg: '@media (min-width: 64em)',
  xl: '@media (min-width: 80em)'
};
var max = {
  sm: '@media (max-width: 35.5em)',
  md: '@media (max-width: 48em)',
  lg: '@media (max-width: 64em)',
  xl: '@media (max-width: 80em)'
};
export { min, max };